$(function() {
  if (!document.getElementById('selectAllProfiles')) return;

  selectAndUnselectAllProfiles();
  showSelectedProfilesCount();
});

function selectAndUnselectAllProfiles() {
  const profileCheckBoxes = $("[type='checkbox'][name='profile_ids[]']")

  $('#selectAllProfiles').on('click', (_e) => {
    profileCheckBoxes.each((_i, el) => { el.checked = true });
  });
  $('#unselectAllProfiles').on('click', (_e) => {
    profileCheckBoxes.each((_i, el) => { el.checked = false });
  });
}

function showSelectedProfilesCount() {
  const profileCheckBoxes = $("[type='checkbox'][name='profile_ids[]']");

  $('#applyProfilesFilter').on('click', (_e) => {
    const applyButton = document.getElementById('applyProfilesFilter');
    const selectedProfilesText = applyButton.dataset.selectedProfilesText;

    let selectedProfilesCount = 0;

    profileCheckBoxes.each((_i, el) => {
      if (el.checked) { selectedProfilesCount++; }
    });
    document.getElementById('profileFiltersModalToggle').textContent =
      `${selectedProfilesCount} ${selectedProfilesText}`;
  })
}
